const EXERCISE_SALE_FILTERS = "exerciseSaleFilters/";

export const EXERCISE_SALE_SEARCH = EXERCISE_SALE_FILTERS + "search";
export const EXERCISE_SALE_SEARCH_CLEAR = EXERCISE_SALE_FILTERS + "clearSearch";
